import type { HowItWorksStep } from "../../types/vtc";
import { useT } from "../../i18n";

interface HowItWorksProps {
  steps: HowItWorksStep[];
}

export default function HowItWorks({ steps }: HowItWorksProps) {
  const t = useT();
  return (
    <section className="mx-auto max-w-7xl px-4 pb-20 pt-12 sm:px-6">
      <h2 className="m-0 mb-7 text-2xl font-medium sm:text-[28px]">
        {t.home.howTitle}
      </h2>

      <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {steps.map((step, i) => (
          <div key={i} className="flex flex-col gap-2">
            <span className="font-mono text-[13px] font-medium text-brand">
              {String(i + 1).padStart(2, "0")}
            </span>
            <h3 className="m-0 text-lg font-medium">{step.title}</h3>
            <p className="m-0 text-[15px] leading-relaxed text-muted">
              {step.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
